import { useTranslation } from 'react-i18next';

export default function Privacy() {
    const { t } = useTranslation();
    return (
        <section className='legal-document' >
            <h1 className='section-title'>{t('legals.privacy.title')}</h1>
            <p>{t('legals.conditions.identification.p1')}</p>
            <p>
                THE FRINGE LABS S.L. <br />
                Calle Santo Ángel 110 portal 2 2ºA  <br />
                28043 Madrid  <br />
                NIF: B06820401
            </p>
            <p>
                Presentada: 11/06/2021 con el número de entrada 1/2021/91184,0, diario 152 asiento 1181 <br />
                Inscrita: 16/06/2021 en el tomo 42031; libro 0; folio 130, sección 8; inscripción 1 con hoja M 744260
            </p>
            <p>{t('legals.privacy.p1')}</p>
            <p>{t('legals.privacy.p2')}</p>
        </section>
    )
}


